module.exports = __webpack_public_path__ + "img/face-frown-slight.a81cc11c.svg";